import './components/modal';
import './components/burger';
import './components/dataFromJson';
import './components/smoothScroll';
import './components/paginationOurPet';
import './components/slider';
